const autocompleteMaintenanceModalFilter = {
  sites: 'Sites',
  equipments: 'Equipment Type',
  place: 'Place',
  status: 'Status Maintenances',
  createdAt: 'Created At',
  sendToMaintenanceDate: 'Send To Maintenance Date',
  returnFromMaintenanceDate: 'Return From Maintenance Date',
  warranty: 'Warranty Deadline',
  expiration: 'Expiration Deadline',
};

export default autocompleteMaintenanceModalFilter;
